import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["$on", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { mq } from '@miro-site/design-tokens';
import * as React from 'react';
import styled from 'styled-components';
import Box from './Box';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledDiv = styled(Box).withConfig({
  displayName: "Hide__StyledDiv",
  componentId: "sc-10ju3q5-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme,
      $on = _ref.$on;
  return Object.keys(theme.mediaQueries).map(function (q) {
    return $on.includes(q) && mq[q]({
      display: 'none'
    });
  });
});
var Hide = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var _ref2$$on = _ref2.$on,
      $on = _ref2$$on === void 0 ? [] : _ref2$$on,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/_jsx(StyledDiv, _objectSpread(_objectSpread({
    ref: ref,
    $on: $on
  }, props), {}, {
    children: children
  }));
});
Hide.displayName = 'Hide';
export default Hide;